import api from "@/lib/axios";

export const getUsers = async () => {
  const { data } = await api.get("/access/users");
  return data.data;
};

export const createUser = async (payload) => {
  const { data } = await api.post("/access/users", payload);
  return data.data;
};

export const updateUser = async (id, payload) => {
  const { data } = await api.patch(`/access/users/${id}`, payload);
  return data.data;
};

export const deleteUser = async (id) => {
  const { data } = await api.delete(`/access/users/${id}`);
  return data.data;
};
